<app-chat [chatType]="chatType.COMPANY"
          description="This chatbot is configured to answer your questions concerning INTERNAL Digiteq documents."
></app-chat>
